import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {NgClass} from '@angular/common';

@Component({
    selector: 'lib-dialog-header',
    templateUrl: './dialog-header.component.html',
    styleUrls: ['./dialog-header.component.css'],
    standalone: false
})



export class DialogHeaderComponent {

  @Input() titulok: string;
  @Input() predmetNazov: string;
  @Input() predmetSkratka: string;
  @Input() predmetRozsah: string;

  @Input() skratkyANazvyPredmetov: string[][];

  @Input() doplnujuciText: string;

  @Input() uzsiLavyOkraj = false;






}
